import {
  UPLOAD_ATTACHMENT,
  UPLOAD_ATTACHMENT_SUCCESS,
  UPLOAD_ATTACHMENT_ERROR,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_ERROR,
  GENERATE_OUTLINE,
  GENERATE_OUTLINE_SUCCESS,
  GENERATE_OUTLINE_ERROR,
  UPDATE_OUTLINE,
  UPDATE_OUTLINE_SUCCESS,
  UPDATE_OUTLINE_ERROR,
  CHECK_ATTACHMENT_STATUS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR,
  GENERATE_COURSE,
  GENERATE_COURSE_ERROR,
  GENERATE_COURSE_SUCCESS,
  GET_RECENT_ATTACHMENTS,
  GET_DOCUMENT_HEADERS,
  GET_DOCUMENT_HEADERS_SUCCESS,
  GET_DOCUMENT_HEADERS_ERROR,
  GET_ATTACHMENT_TITLES,
  GET_ATTACHMENT_TITLES_SUCCESS,
  GET_ATTACHMENT_TITLES_ERROR,
  CLEAR_OUTLINE,
  SUGGEST_GOAL,
  SUGGEST_GOAL_SUCCESS,
  SUGGEST_GOAL_ERROR,
  SUGGEST_SECTION_TITLE,
  SUGGEST_SECTION_TITLE_SUCCESS,
  SUGGEST_SECTION_TITLE_ERROR,
  SUGGEST_PAGE_TITLE,
  SUGGEST_PAGE_TITLE_SUCCESS,
  SUGGEST_PAGE_TITLE_ERROR,
  SUGGEST_PAGE_OUTLINE,
  SUGGEST_PAGE_OUTLINE_SUCCESS,
  SUGGEST_PAGE_OUTLINE_ERROR,
  ADD_ATTACHMENT_URL,
  ADD_ATTACHMENT_URL_SUCCESS,
  ADD_ATTACHMENT_URL_ERROR,
  SET_COURSE_ATTACHMENTS,
} from './type'

export const aICreatorGetRecentAttachmentsAction = callback => {
  return {
    type: GET_RECENT_ATTACHMENTS,
    payload: { callback },
  }
}

export const aICreatorUploadAttachmentAction = (
  formData,
  fileName,
  callback,
) => {
  return {
    type: UPLOAD_ATTACHMENT,
    payload: { formData, fileName, callback },
  }
}

/**
 *
 * @param {*} response
 * @param {*} fileName
 */
export const aICreatorUploadAttachmentSuccess = (response, fileName) => {
  return {
    type: UPLOAD_ATTACHMENT_SUCCESS,
    payload: { response, fileName },
  }
}

/**
 *
 */

export const aICreatorUploadAttachmentError = () => {
  return {
    type: UPLOAD_ATTACHMENT_ERROR,
  }
}

/**
 *
 * @param {*} chatId
 * @param {*} attachmentId
 * @param {*} callback
 */

export const aICreatorDeleteAttachmentAction = (attachmentId, callback) => {
  return {
    type: DELETE_ATTACHMENT,
    payload: { attachmentId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const aICreatorDeleteAttachmentSuccess = response => {
  return {
    type: DELETE_ATTACHMENT_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */

export const aICreatorDeleteAttachmentError = () => {
  return {
    type: DELETE_ATTACHMENT_ERROR,
  }
}

/**
 *
 * @param {*} outline
 * @param {*} chatId
 * @param {*} callback
 *
 */
export const aICreatorUpdateOutlineAction = (req, outlineId, callback) => {
  return {
    type: UPDATE_OUTLINE,
    payload: { req, outlineId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const aICreatorUpdateOutlineSuccess = response => {
  return {
    type: UPDATE_OUTLINE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const aICreatorUpdateOutlineError = () => {
  return {
    type: UPDATE_OUTLINE_ERROR,
  }
}

/**
 *
 * @param {*} attachmentId
 * @param {*} callback
 *
 */
export const aICreatorCheckAttachmentStatusAction = (
  attachmentId,
  callback,
) => {
  return {
    type: CHECK_ATTACHMENT_STATUS_AI_CREATOR,
    payload: { attachmentId, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const aICreatorCheckAttachmentStatusSuccess = response => {
  return {
    type: CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
    payload: { response },
  }
}

/**
 *
 */
export const aICreatorCheckAttachmentStatusError = () => {
  return {
    type: CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR,
  }
}

/**
 *
 * @param {*} req
 * @param {*} callback
 *
 */
export const aICreatorGenerateOutlineAction = (req, callback) => {
  return {
    type: GENERATE_OUTLINE,
    payload: { req, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const aICreatorGenerateOutlineSuccess = response => {
  return {
    type: GENERATE_OUTLINE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const aICreatorGenerateOutlineError = () => {
  return {
    type: GENERATE_OUTLINE_ERROR,
  }
}

/**
 *
 * @param {*} req
 * @param {*} callback
 *
 */
export const aICreatorGenerateCourseAction = (req, callback) => {
  return {
    type: GENERATE_COURSE,
    payload: { req, callback },
  }
}

/**
 *
 * @param {*} response
 */
export const aICreatorGenerateCourseSuccess = response => {
  return {
    type: GENERATE_COURSE_SUCCESS,
    payload: { response },
  }
}

/**
 *
 */
export const aICreatorGenerateCourseError = () => {
  return {
    type: GENERATE_COURSE_ERROR,
  }
}

export const aICreatorGetDocumentHeadersAction = (outlineId, callback) => {
  return {
    type: GET_DOCUMENT_HEADERS,
    payload: { outlineId, callback },
  }
}

export const aICreatorGetDocumentHeadersSuccess = response => {
  return {
    type: GET_DOCUMENT_HEADERS_SUCCESS,
    payload: { response },
  }
}

export const aICreatorGetDocumentHeadersError = () => {
  return {
    type: GET_DOCUMENT_HEADERS_ERROR,
  }
}

export const aICreatorGetAttachmentTitlesAction = (attachmentIds, callback) => {
  return {
    type: GET_ATTACHMENT_TITLES,
    payload: { attachmentIds, callback },
  }
}

export const aICreatorGetAttachmentTitlesSuccess = response => {
  return {
    type: GET_ATTACHMENT_TITLES_SUCCESS,
    payload: { response },
  }
}

export const aICreatorGetAttachmentTitlesError = () => {
  return {
    type: GET_ATTACHMENT_TITLES_ERROR,
  }
}

export const aICreatorClearOutlineAction = () => {
  return {
    type: CLEAR_OUTLINE,
  }
}

export const aICreatorSuggestGoalAction = (requestData, callback) => {
  return {
    type: SUGGEST_GOAL,
    payload: { requestData, callback },
  }
}

export const aICreatorSuggestGoalSuccess = response => {
  return {
    type: SUGGEST_GOAL_SUCCESS,
    payload: { response },
  }
}

export const aICreatorSuggestGoalError = () => {
  return {
    type: SUGGEST_GOAL_ERROR,
  }
}

export const aICreatorSuggestSectionTitleAction = (requestData, callback) => {
  return {
    type: SUGGEST_SECTION_TITLE,
    payload: { requestData, callback },
  }
}

export const aICreatorSuggestSectionTitleSuccess = response => {
  return {
    type: SUGGEST_SECTION_TITLE_SUCCESS,
    payload: { response },
  }
}

export const aICreatorSuggestSectionTitleError = () => {
  return {
    type: SUGGEST_SECTION_TITLE_ERROR,
  }
}

export const aICreatorSuggestPageTitleAction = (requestData, callback) => {
  return {
    type: SUGGEST_PAGE_TITLE,
    payload: { requestData, callback },
  }
}

export const aICreatorSuggestPageTitleSuccess = response => {
  return {
    type: SUGGEST_PAGE_TITLE_SUCCESS,
    payload: { response },
  }
}

export const aICreatorSuggestPageTitleError = () => {
  return {
    type: SUGGEST_PAGE_TITLE_ERROR,
  }
}

export const aICreatorSuggestPageOutlineAction = (requestData, callback) => {
  return {
    type: SUGGEST_PAGE_OUTLINE,
    payload: { requestData, callback },
  }
}

export const aICreatorSuggestPageOutlineSuccess = response => {
  return {
    type: SUGGEST_PAGE_OUTLINE_SUCCESS,
    payload: { response },
  }
}

export const aICreatorSuggestPageOutlineError = () => {
  return {
    type: SUGGEST_PAGE_OUTLINE_ERROR,
  }
}

export const aICreatorAddAttachmentUrlAction = (req, callback) => {
  return {
    type: ADD_ATTACHMENT_URL,
    payload: { req, callback },
  }
}

export const aICreatorAddAttachmentUrlSuccess = response => {
  return {
    type: ADD_ATTACHMENT_URL_SUCCESS,
    payload: { response },
  }
}

export const aICreatorAddAttachmentUrlError = () => {
  return {
    type: ADD_ATTACHMENT_URL_ERROR,
  }
}

export const aICreatorSetCourseAttachments = attachments => {
  return {
    type: SET_COURSE_ATTACHMENTS,
    payload: { attachments },
  }
}
